import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex gap-2 w-full mb-4" }
const _hoisted_2 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
      return (_openBlock(), _createElementBlock("button", {
        key: tab.value,
        class: _normalizeClass([
        'flex-1 py-2 rounded-md font-medium transition',
        _ctx.selectedTab === tab.value
          ? 'bg-primary-purple text-white shadow'
          : 'bg-gray-100 text-gray-700 hover:bg-gray-200',
      ]),
        onClick: ($event: any) => (_ctx.$emit('tab-change', tab.value))
      }, _toDisplayString(tab.label), 11, _hoisted_2))
    }), 128))
  ]))
}